import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, UserRoundPlus } from "lucide-react";
import { errorMessage, get, post } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const RemovedLocksmithsDialog = ({ open, onOpenChange, onRestored }) => {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    setList(null);
    get("/locksmiths/removed").then(setList).catch((e) => { toast.error(errorMessage(e)); setList([]); });
  }, [open]);

  const restore = async (l) => {
    setBusy(l.id);
    try {
      await post(`/locksmiths/${l.id}/restore`);
      toast.success(`${l.full_name || l.email} added back to your team`);
      setList((cur) => cur.filter((x) => x.id !== l.id));
      onRestored();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="removed-locksmiths-dialog">
        <DialogHeader>
          <DialogTitle>Add back a removed locksmith</DialogTitle>
          <DialogDescription>They keep their existing account and password and get an email letting them know.</DialogDescription>
        </DialogHeader>
        {!list && <div className="flex justify-center py-6"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>}
        {list && !list.length && <p className="py-6 text-center text-sm text-slate-500" data-testid="removed-locksmiths-empty">No removed locksmiths.</p>}
        {list && list.length > 0 && (
          <ul className="max-h-[60vh] divide-y divide-slate-100 overflow-y-auto">
            {list.map((l) => (
              <li key={l.id} className="flex items-center justify-between gap-3 py-3" data-testid={`removed-locksmith-${l.id}`}>
                <div className="min-w-0">
                  <p className="truncate font-medium text-slate-900">{l.full_name || "—"}</p>
                  <p className="truncate text-xs text-slate-500">{l.email}</p>
                </div>
                <Button size="sm" className="bg-blue-700 hover:bg-blue-800" disabled={busy === l.id} onClick={() => restore(l)} data-testid={`restore-locksmith-${l.id}`}>
                  {busy === l.id ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <UserRoundPlus className="mr-1 h-4 w-4" />} Add back
                </Button>
              </li>
            ))}
          </ul>
        )}
      </DialogContent>
    </Dialog>
  );
};
